import React, { useState } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { Button, Col, Row, Spinner } from 'reactstrap';
import ModalSheet from '../modal-sheet/modal-sheet.component';
import { connect } from 'react-redux';

import {
  setIsCreatePaymentMethodModalOpen,
  setIsListPaymentMethodsModalOpen,
} from '../../../../redux/modal/modal.actions';
import PropTypes from 'prop-types';
import {
  PaymentElement,
  useElements,
  useStripe,
} from '@stripe/react-stripe-js';
import SkeletonLoader from '../../lazyload/skeleton-loader/skeleton-loader.component';
import { customMessageNotification } from '../../../../utility/notification/notification.service';
import { fetchPaymentMethods } from '../../../../redux/me/me.actions';
import { setCreatePaymentMethodClientSecret } from '../../../../redux/me/me.actions';
import { config } from '../../../../configs/app.config';
import DefaultAlert from '../../alerts/default-alert/default-alert.component';

const CreatePaymentMethodModal = ({
  isOpen,
  store,

  fetchPaymentMethods,
  setIsCreatePaymentMethodModalOpen,
  setCreatePaymentMethodClientSecret,
  setIsListPaymentMethodsModalOpen,
}) => {
  const intl = useIntl();
  const stripe = useStripe();
  const elements = useElements();

  const [isPaymentElementReady, setIsPaymentElementReady] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleCreate = async (event) => {
    if (event) event.preventDefault();

    if (stripe && elements) {
      setIsSubmitting(true);

      const { error } = await stripe.confirmSetup({
        elements: elements,
        redirect: 'if_required',
        confirmParams: {
          return_url: window.location.href, // TODO: set the right url
        },
      });

      if (error) {
        customMessageNotification('warn', error.message);
      } else {
        setCreatePaymentMethodClientSecret(null);
        fetchPaymentMethods();
        setIsListPaymentMethodsModalOpen(true);
      }

      setIsSubmitting(false);
    }
  };

  return (
    <ModalSheet
      isOpen={isOpen}
      closeModal={() => setIsCreatePaymentMethodModalOpen(false)}
      title={intl.formatMessage({ id: 'createNewPaymentMethodTitle' })}
      footer={
        <Button
          color="primary"
          className="w-100 mt-2 m-auto"
          disabled={isSubmitting}
          onClick={handleCreate}
        >
          {isSubmitting ? (
            <>
              <Spinner color="white" size="sm" />
              <span className="ml-50">
                <FormattedMessage id="loading" />
              </span>
            </>
          ) : (
            <FormattedMessage id="savePaymentMethodTitle" />
          )}
        </Button>
      }
    >
      <div className="px-1">
        {['dev', 'demo'].includes(config.env) && (
          <>
            <DefaultAlert
              color="warning"
              msg={intl.formatMessage({ id: 'demoModeCheckoutPaymentAlert' })}
            />
            <DefaultAlert
              color="info"
              msg={intl.formatMessage({
                id: 'demoModeCheckoutPaymentInfo',
              })}
            />
          </>
        )}

        {/* PaymentElement and it's skeleton loader */}
        <form>
          {!isPaymentElementReady && (
            <Row>
              <Col xs={4} className="pr-25 pb-2">
                <SkeletonLoader height="72px" />
              </Col>
              <Col xs={4} className="px-25 pb-2">
                <SkeletonLoader height="72px" />
              </Col>
              <Col xs={4} className="pl-25 pb-2">
                <SkeletonLoader height="72px" />
              </Col>
              <Col xs={12}>
                <SkeletonLoader height="38px" />
              </Col>
              <Col xs={6} className="pr-25 py-2">
                <SkeletonLoader height="38px" />
              </Col>
              <Col xs={6} className="pl-25 py-2">
                <SkeletonLoader height="38px" />
              </Col>
              <Col xs={12}>
                <SkeletonLoader height="38px" />
              </Col>
            </Row>
          )}
          <div hidden={!isPaymentElementReady}>
            <PaymentElement
              onReady={() => setIsPaymentElementReady(true)}
              options={{
                business: { name: store?.name + ' (via servier.bar)' },
                readOnly: isSubmitting,
              }}
            />
          </div>
        </form>
      </div>
    </ModalSheet>
  );
};

CreatePaymentMethodModal.propTypes = {
  isOpen: PropTypes.bool,
};

const mapStateToProps = (state) => ({
  isOpen: state.modals.isCreatePaymentMethodModalOpen,
  store: state.store.store,
});

export default connect(mapStateToProps, {
  fetchPaymentMethods,
  setIsCreatePaymentMethodModalOpen,
  setCreatePaymentMethodClientSecret,
  setIsListPaymentMethodsModalOpen,
})(CreatePaymentMethodModal);
